export default __webpack_public_path__ + "static/media/4.2d3045df.mp4";